// extracted by mini-css-extract-plugin
export default {"container":"QK-z","topReviewHeading":"RK-z","criticalReview":"SK-z","favorableReview":"TK-z","vsSeparator":"UK-z"};